import React from 'react';
import { shouldShowVeloHeader } from '../../../../utils';
import { CustomLink } from '../../PageElements/CustomLink';
import { StoreContext } from '../../../appContext/StoreProvider';
import style from './menuLogo.scss';

export const MenuLogo = ({
  onClick,
  primaryText,
  secondaryText,
  LogoComponent,
  classNames = {},
}) => {
  const { store } = React.useContext(StoreContext);
  const shouldHideMenuButton = !shouldShowVeloHeader(store.viewer.category);

  return (
    <CustomLink
      onClick={onClick}
      className={`${style.logoContainer} ${classNames.logoContainer} ${
        shouldHideMenuButton ? style.withoutMenuButton : ''
      }`}
      to={{
        pathname: '/',
      }}
    >
      {LogoComponent && (
        <LogoComponent
          className={`${style.logo} ${classNames.logo}`}
          data-hook="header-logo"
        />
      )}
      {primaryText && <span className={style.dev}>{primaryText}</span>}
      {secondaryText && <span className={style.apiText}>{secondaryText}</span>}
    </CustomLink>
  );
};
